import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import RegularSignupComponent from "components/core/signups/regular-signup-component/regular-signup-component";
import { StyledStickySignupButton } from "./sticky-signup-button-component.scss";
import { trackEvent } from "/services/bigbrain-service";
import { STICKY_SIGNUP_BUTTON_IS_VISIBLE } from "/constants/bigbrain-event-types";
const DEFAULT_SCROLL_THRESHOLD = 0;
const StickySignupButtonComponent = ({ scrollThreshold })=>{
    const [isVisible, setIsVisible] = useState(false);
    const [mounted, setMounted] = useState(false);
    const hasTrackedVisibility = useRef(false);
    const getScrollThreshold = useCallback(()=>{
        const threshold = scrollThreshold ? parseInt(scrollThreshold, 10) : DEFAULT_SCROLL_THRESHOLD;
        return isNaN(threshold) ? DEFAULT_SCROLL_THRESHOLD : threshold;
    }, [
        scrollThreshold
    ]);
    const handleScroll = useCallback(()=>{
        const scrollPosition = window.scrollY || window.pageYOffset;
        const threshold = getScrollThreshold();
        const shouldShow = scrollPosition > threshold;
        setIsVisible(shouldShow);
    }, [
        getScrollThreshold
    ]);
    useEffect(()=>{
        setMounted(true);
        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        handleScroll
    ]);
    useEffect(()=>{
        if (isVisible && !hasTrackedVisibility.current) {
            trackEvent(STICKY_SIGNUP_BUTTON_IS_VISIBLE);
            hasTrackedVisibility.current = true;
        }
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ _jsx(StyledStickySignupButton, {
        isVisible: isVisible,
        mounted: mounted,
        children: /*#__PURE__*/ _jsx(RegularSignupComponent, {
            forceInputHide: true,
            withButtonArrow: true,
            placement: "sticky_signup_button",
            origin: "sticky_signup_button"
        })
    });
};
export default StickySignupButtonComponent;
